import { SlotGameType1_21 } from '../SlotGameType1_21';

export class FairyMagicForestClassic21 extends SlotGameType1_21
{
}
